
import { ApiManufacturer } from "@api/interfaces";
import { Avatar } from "@/components/DesignSystem/Avatar/Avatar";
import { AppConfig } from "@/constants/AppConfig";
import { AvatarProps } from "@mui/material";

interface ManufacturerAvatarProps extends AvatarProps {
  manufacturer?: ApiManufacturer | null,
  size?: number,
}

export const ManufacturerAvatar = ({
  manufacturer,
  size = 56,
  ...rest
}: ManufacturerAvatarProps) => {
  return (
    <Avatar
      defaultIcon="manufacturer"
      outlined={true}
      shape="square"
      size={size}
      src={manufacturer?.logomark ? `${AppConfig.staticImageHost}/${manufacturer.logomark}` : undefined}
      {...rest}
    />
  );
};